import { isVisibleAt, normalizePrivacy } from "@vortex-os/core";
import type { Privacy } from "@vortex-os/core";
import type { RenderWarning } from "./types.js";

const SECTION_PATTERN =
  /<!--\s*vortex:privacy\s+(\w+)\s*-->([\s\S]*?)<!--\s*\/vortex:privacy\s*-->/g;

export interface StripResult {
  readonly content: string;
  readonly warnings: readonly RenderWarning[];
}

/**
 * Remove section blocks whose declared privacy exceeds the target.
 *
 * Each section is delimited by `<!-- vortex:privacy LEVEL -->` and
 * `<!-- /vortex:privacy -->`. Sections at or below target privacy keep
 * their body (markers themselves are removed). Sections above target are
 * stripped entirely and a `section-stripped` warning is reported.
 *
 * Sections do not nest; the parser does not support nesting.
 */
export function stripPrivateSections(
  content: string,
  targetPrivacy: Privacy,
): StripResult {
  const warnings: RenderWarning[] = [];
  const out = content.replace(SECTION_PATTERN, (_match, levelRaw: string, body: string) => {
    const sectionPrivacy = normalizePrivacy(levelRaw);
    if (isVisibleAt(sectionPrivacy, targetPrivacy)) {
      return body;
    }
    warnings.push({
      kind: "section-stripped",
      reason: `Stripped section with privacy=${sectionPrivacy} (above target ${targetPrivacy})`,
    });
    return "";
  });
  return { content: out, warnings };
}
